/**
 * Report module.
 * @module report
 */
var md5 = require('md5')
var opt = require('./opt');
var util = require('./util');
var JSON2 = 'JSON' in window ? JSON : require('JSON2');

var _queue = [];

var _createUrl = function (queue) {
    var url = opt.furl;
    var param;
    var query;
    var value; // 用于计算签名
    var sig;

    if (queue.length === 1) {
        param = util.deepExtend({}, opt.comm, queue[0]);
    } else {
        param = util.deepExtend({}, opt.comm, {
            il: queue
        });
    }

    param = JSON2.stringify(param);

    value = 'appId=' + opt.appid + 'log=' + param + 'v=' + opt.v;

    sig = md5(value + opt.s);

    query = 'appId=' + opt.appid + '&log=' + encodeURIComponent(param) + '&v=' + opt.v + '&sig=' + sig;

    return url + '?' + query; 
};

/**
 * @func beacon
 * @desc 统一回调的Image Beacon
 */
function beacon (url) {
    util.imageBeacon(url, function () {
        opt.debug && util.print.msg('Report success: ' + url + ':)');
    }, function () {
        opt.debug && util.print.err('Report error: ' + url + ':(');
    });
}

/**
 * @var _lastURL
 * @desc URL缓存，存放上一次未上报的URL
 */
var _lastUrl = '';

/**
 * @func report
 * @desc 上报
 * @param {object} param - 上报参数对象
 */
var report = module.exports = function (param) {
    var force; // 是否实时上报

    if (param.force === false) {
        force = param.force;
    } else {
        force = opt.force;
    }


    delete param.force;

    _queue.push(util.deepExtend({}, param, {
        tm: Math.round((new Date()).getTime() / 1000)
    }));

    if (opt.debug) {
        util.print.msg('Report has been push into queue: ' + JSON2.stringify(param));
    }

    var url = _createUrl(_queue);

    if (url.length > util.getBroswer()) {
        if (_queue.length === 1) {
            util.print.err('Report error: your single report is too long.');
            _queue = [];
        } else {
            beacon(_lastUrl);
            _queue.splice(0, _queue.length - 1);

            if (force) {
                beacon(_createUrl(_queue));
            }
        }
    } else {
        if (force) {
            beacon(url);
            _queue = [];
        } else {
            _lastUrl = url;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/report.js
// module id = 8
// module chunks = 0